//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CommonPage",
  data: function data() {
    return {};
  },
  props: ["count", "index"],
  mounted: function mounted() {},
  watch: {
    $route: function $route(to, from) {
      if (to.query.IssueId && from.query.IssueId) {
        if (to.query.IssueId != from.query.IssueId) {
          this.$emit("pageindex", 1).index.PageIndex = 1;
        } else {
          this.reload();
        }
      }

      if (to.query.Key && from.query.Key) {
        if (to.query.Key !== from.query.Key) {
          if (this.$route.query) {
            this.$emit("pageindex", 1).index.PageIndex = 1;
          } else {
            this.reload();
          }
        }
      }
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.$emit("pageSize", val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit("pageindex", val);
      window.scrollTo(0, 0);
    }
  }
};